import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './langs/en.json';
import translationFR from './langs/fr.json';

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(initReactI18next)  // Utilisation correcte d'initReactI18next
  .init({
    resources,
    lng: 'en', // Langue par défaut
    keySeparator: false,
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;
